export type NavSection = 'jobs' | 'capture' | 'queue' | 'flagged';

/**
 * Which tab a path belongs to. Capture routes carry their job
 * (`/jobs/:jobId/capture/...`) and so sit under the job's own path, which a
 * prefix match would light as Jobs. A job view and a capture result both
 * belong to Jobs, which is where the operator reached them from.
 */
export function activeSection(pathname: string): NavSection | null {
  if (pathname === '/capture' || /^\/jobs\/[^/]+\/capture(\/|$)/.test(pathname)) return 'capture';
  if (pathname === '/work' || pathname.startsWith('/jobs/') || /^\/capture\/[^/]+\/result$/.test(pathname)) {
    return 'jobs';
  }
  if (pathname.startsWith('/queue')) return 'queue';
  if (pathname.startsWith('/flagged')) return 'flagged';
  return null;
}
